export const metricDefinitions = {
  'editor-sync': { operation: 'editor', basis: 'synchronous-wall', slowMs: 50 },
  'editor-worker': {
    operation: 'editor',
    basis: 'wall-including-worker-wait',
    slowMs: 100,
  },
  'graph-rebuild': { operation: 'graph', basis: 'synchronous-wall', slowMs: 50 },
  'graph-cooperative': {
    operation: 'graph',
    basis: 'wall-including-yields',
    slowMs: 100,
  },
  'simulation-input': {
    operation: 'simulation',
    basis: 'synchronous-input-dispatch-and-propagation-wall',
    slowMs: 16,
  },
  'simulation-drain': { operation: 'simulation', basis: 'synchronous-wall', slowMs: 16 },
  save: { operation: 'save', basis: 'wall-including-storage', slowMs: 250 },
  'load-storage': {
    operation: 'load',
    basis: 'wall-including-storage-and-hydration',
    slowMs: 250,
  },
  load: { operation: 'load', basis: 'wall-including-yields', slowMs: 250 },
  'import-read': { operation: 'import', basis: 'wall-including-file-read', slowMs: 250 },
  'import-apply': { operation: 'import', basis: 'synchronous-wall', slowMs: 100 },
  interaction: { operation: 'render', basis: 'input-to-next-paint-wall', slowMs: 104 },
  'long-task': { operation: 'render', basis: 'main-thread-task-wall', slowMs: 50 },
} as const;
export type PerformanceMetric = keyof typeof metricDefinitions;
export const workloadBuckets = [
  'unknown',
  '0',
  '1-99',
  '100-999',
  '1000-9999',
  '10000+',
] as const;
export interface TimingSummary {
  metric: PerformanceMetric;
  samples: number;
  slowSamples: number;
  totalMs: number;
  maxMs: number;
  workload: (typeof workloadBuckets)[number];
}
export function safeTiming(value: unknown): TimingSummary | undefined {
  if (!value || typeof value !== 'object') return;
  const { metric, samples, slowSamples, totalMs, maxMs, workload } =
    value as TimingSummary;
  if (
    typeof metric !== 'string' ||
    !Object.hasOwn(metricDefinitions, metric) ||
    !Number.isSafeInteger(samples) ||
    samples < 1 ||
    samples > 100000 ||
    !Number.isSafeInteger(slowSamples) ||
    slowSamples < 0 ||
    slowSamples > samples ||
    !Number.isFinite(totalMs) ||
    totalMs < 0 ||
    totalMs > 30000000000 ||
    !Number.isFinite(maxMs) ||
    maxMs < 0 ||
    maxMs > 300000 ||
    totalMs < maxMs ||
    !workloadBuckets.includes(workload)
  )
    return;
  return { metric, samples, slowSamples, totalMs, maxMs, workload };
}
